import './style.css';

const Footer = () => {
    return(
        <footer>
            <h5>&#169; Welberth Marques</h5>
        </footer>
    );
}

export default Footer;